import session from './session'

var uri = process.env.API_ENDPOINT

export default {
  createCustomer ({data, email}) {
    console.debug('***** Called createCustomer *****')
    return session.post(uri + '/api/user/create_customer/', {data, email})
  }
}



// WEBPACK FOOTER //
// ./src/api/setting.js